import React from "react";
import GoogleReviewRequestList from "../../components/event/GoogleReviewRequestList";

const GoogleReviewRequestsPage = () => {
    return <GoogleReviewRequestList/>
}

export default GoogleReviewRequestsPage;
